<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  switcher?: boolean
  value?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  switcher: false,
  value: false,
})

const localValue = ref(props.value)

watch(
  () => props.value,
  (newVal: boolean) => {
    localValue.value = newVal
  },
)

// Define all the events that b-form-checkbox can emit
defineEmits(['update:modelValue', 'change', 'input'])
</script>

<template>
  <b-form-checkbox
    :switch="switcher"
    v-bind="$attrs"
    v-model="localValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    @change="$emit('change', $event)"
    @input="$emit('input', $event)"
  >
    <slot />
  </b-form-checkbox>
</template>
